import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";

export function PageShell({ title, subtitle, back = "/", children, accent, testId }: { title: string; subtitle?: string; back?: string; children: ReactNode; accent?: string; testId: string }) {
  return (
    <div className="mx-auto max-w-3xl px-3 py-3 sm:px-4 sm:py-5" data-testid={testId}>
      {back && <Link to={back} className="mb-2 inline-flex items-center gap-1 text-sm font-extrabold uppercase tracking-wide hover:underline" data-testid="page-back-link">
        <ChevronLeft className="h-4 w-4" strokeWidth={3} /> Back
      </Link>}
      <div className="mb-3 sm:mb-4">
        <h1 className={`ua-logo text-4xl sm:text-5xl [overflow-wrap:anywhere] ${accent || ""}`}>{title}</h1>
        {subtitle && <p className="mt-1 text-sm font-semibold text-[#6b3a12] md:text-base">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function Panel({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`ua-tile rounded-[20px] border-[3px] border-[#F2D9B8] bg-white p-4 hover:!transform-none ${className}`}>{children}</div>;
}
